export default __webpack_public_path__ + "static/media/003-falling rocks.daff62e3.png";